import { motion } from "framer-motion";
import { useLang } from "../lib/LanguageContext";
import { galleryImages } from "../lib/menuData";

export const Gallery = () => {
  const { t } = useLang();

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-brand-sand"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.32em] text-brand-blue font-medium">
            {t.gallery.eyebrow}
          </span>
          <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight text-brand-ink">
            {t.gallery.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-brand-mocha leading-relaxed">
            {t.gallery.subtitle}
          </p>
        </div>

        <div className="mt-14 masonry">
          {galleryImages.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              data-testid={`gallery-item-${i}`}
              className="group relative overflow-hidden rounded-2xl ring-1 ring-brand-border bg-white"
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                  img.span === "tall"
                    ? "aspect-[3/4]"
                    : img.span === "wide"
                      ? "aspect-[4/3]"
                      : "aspect-square"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-coffee/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <p className="absolute bottom-4 left-4 right-4 text-xs uppercase tracking-[0.2em] text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                {img.alt}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
